import React from 'react';
import { Typography, Link } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

const useStyles = makeStyles((theme) => ({
  uiucMsg: {
    // color: 'white',
    marginLeft: '50px',
    fontSize: '14px',
    lineheight: '22px',
    textAlign: 'right',
    alignItems: 'center',
    display: 'inline-flex',
    [theme.breakpoints.down(1279)]: {
      textAlign: 'left',
      marginLeft: '0px',
      display: 'inline-flex',
      alignItems: 'center',
    },

    [theme.breakpoints.down(958)]: {
      width: '100%',
      display: 'flex',
      margin: '5px 0px',
      alignItems: 'center',
    },
  },
  link: {
    // color: 'white',
    textDecoration: 'underline',
    marginLeft: '5px',
    marginRight: '5px',
    color: theme.palette.text.primary,
  },
}));

export default function CornMessage() {
  const classes = useStyles();
  return (
    <Typography classes={{ root: classes.uiucMsg }} color="textPrimary">
      Made with
      <img
        alt="corn"
        data-src="/emojis/solid_corn.svg"
        className="lazyload"
        style={{ margin: '-2px 5px 0px 5px', width: '18px', height: '18px' }}
      />
      at
      <a
        className={classes.link}
        target="_blank"
        rel="noopener noreferrer"
        href="https://illinois.edu"
      >
        UIUC
      </a>
    </Typography>
  );
}
